export const BULK_PACKAGE_VERIFICATION_PROMPT = 'bulk-package-verification-prompt';
